export default __webpack_public_path__ + "static/media/rdc_window.9daee475.png";